import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    PRIMARY_OUTLET,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import {AuthService} from 'app/core/_services/auth.service';
import {Observable} from 'rxjs';
import {UserService} from 'app/core/_services/user.service';
import {UtilitiesService} from 'app/core/_services/utilities.service';
import {CampaignEventsService} from '../../booking-flow/services/campaign-events.service';
import {PARTNER_ID} from '../constants';
import {environment} from 'environments/environment';

@Injectable()
export class YMGuard implements CanActivate {

    constructor(private authService: AuthService,
                private userService: UserService,
                private campaignEventsService: CampaignEventsService,
                private router: Router) {}

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (!environment.ymRedirect) {
            return true;
        }

        const currentUserData = this.userService.getCurrentUserData();

        if (!this.authService.loggedIn() || UtilitiesService.isEmpty(currentUserData)) {

            const dynamicUrl = this.router.parseUrl(state.url).root.children[PRIMARY_OUTLET].segments.pop();

            // This gets set in the landing-page-details.guard.
            const partnerId = this.campaignEventsService?.landingPageDetail?.partnerId;

            // Allow only users coming into these partner urls to book through wrench.com
            // or else send them to YM. Note we need to be checking both the dynamicUrl AND the partnerId
            // because this guard gets called several times because of redirects and such and sometimes we know the
            // url at this point and sometimes we only know the partnerId.
            if (partnerId === PARTNER_ID.CARPARTS
                || partnerId === PARTNER_ID.SILVERROCK
                || partnerId === PARTNER_ID.GWC
                || partnerId === PARTNER_ID.AMERICANAUTOSHIELD
                || partnerId === PARTNER_ID.BRIDGESTONE
                || dynamicUrl.path === 'silverrockwarranty'
                || dynamicUrl.path === 'silverockwarranty'
                || dynamicUrl.path === 'sr'
                || dynamicUrl.path === 'gwc'
                || dynamicUrl.path === 'gwcwarranty'
                || dynamicUrl.path === 'carparts'
                || dynamicUrl.path === 'americanautoshield') {
                return true;
            } else {
                const params: string = this.campaignEventsService.utmParams();
                window.location.href = $localize`https://wrench.com/book?` + params;
                return false;
            }
        } else if (this.authService.loggedIn() && currentUserData.fleet) {
            return true;
        }
        this.router.navigateByUrl('/book-redirect');
        return false;
    } // canActivate()

}
